import type { CaseStudy, Section } from '../api/types';
import { Reveal } from './Reveal';
import styles from './CaseStudy.module.css';

interface CaseStudiesProps {
  section: Section;
  caseStudies: CaseStudy[];
}

function ExternalIcon() {
  return (
    <svg width="13" height="13" viewBox="0 0 16 16" fill="none" aria-hidden="true">
      <path
        d="M4 12L12 4M12 4H6M12 4V10"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function CaseStudies({ section, caseStudies }: CaseStudiesProps) {
  return (
    <section className="section" id="work">
      <div className="shell">
        <Reveal className="sectionHead">
          <p className="eyebrow">{section.eyebrow}</p>
          <h2>{section.title}</h2>
          {section.body ? <p className="lead">{section.body}</p> : null}
        </Reveal>

        {caseStudies.map((study) => (
          <Reveal key={study.id} className={styles.card}>
            <div className={styles.top}>
              <div>
                <h3 className={styles.title}>{study.title}</h3>
                <p className={styles.body}>{study.body}</p>
                <a
                  className={styles.link}
                  href={study.url}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {study.urlLabel}
                  <ExternalIcon />
                </a>
              </div>

              <dl className={styles.facts}>
                {study.facts.map((fact) => (
                  <div key={fact.label} className={styles.fact}>
                    <dt>{fact.label}</dt>
                    <dd>{fact.value}</dd>
                  </div>
                ))}
              </dl>
            </div>

            <div className={styles.strip}>
              {study.tools.map((tool) => (
                <span key={tool}>{tool}</span>
              ))}
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
